module.exports = __webpack_public_path__ + "img/resourcePanelIcon.b1bc1b0a.svg";